// بارگذار استوری‌ها: هر صفحه‌ای که می‌خواهد استوری داشته باشد فقط loadStories() را از js اصلی‌اش صدا می‌زند
// (نه <link>/<script> در بلید). ماژول و scss آن (product-stories.js) فقط وقتی `[data-pstories]` در صفحه باشد
// با import() دانلود می‌شود و Vite هنگام همین import، css را هم لود می‌کند و صبر می‌کند تا آماده شود.

let storiesModule = null;

function ensureStories() {
  if (!document.querySelector('[data-pstories]')) return;
  storiesModule ??= import('./product-stories.js');
  storiesModule.then((m) => m.initProductStories());
}

export function loadStories() {
  ensureStories();
  // wire:navigate: DOM صفحهٔ جدید عوض می‌شود؛ ماژول کش است و init روی هر host فقط یک‌بار اجرا می‌شود.
  document.addEventListener('livewire:navigated', ensureStories);
  document.addEventListener('livewire:navigating', () => {
    storiesModule?.then((m) => m.destroyProductStories());
  });
}
